// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlock_root__8_keY","title":"PricingBlock_title__xJJCA"};